import { ButtonGroup, ButtonGroupProps } from "@mui/material";
import React, { ReactNode } from "react";
import styles from "./CustomButtonGroup.module.css";

type Size = "sm" | "md" | "lg";
type Color = "primary" | "secondary";
type Variant = "contained" | "outlined" | "text";
interface CustomButtonGroupProps extends Omit<ButtonGroupProps, "size" | "color" | "variant"> {
	children?: ReactNode;
	size?: Size;
	color?: Color;
	variant?: Variant;
}

const CustomButtonGroup = ({
	children,
	color = "primary",
	fullWidth = false,
	size = "md",
	variant = "text",
}: CustomButtonGroupProps) => (
	<ButtonGroup
		className={styles.btnGroup}
		color={color}
		data-color={color}
		data-size={size}
		data-variant={variant}
		fullWidth={fullWidth}
		variant="text"
	>
		{children}
	</ButtonGroup>
);

export default CustomButtonGroup;
